import CalendarDayView from './calendar-day-view';

export default CalendarDayView;
